import React from 'react';

const OrderCard = ({ order, readonly, selected, onSelect, showInvoiceAction }) => {
    // Função para determinar a cor de fundo
    const getBackgroundColor = () => {
        if (order.hasLabel) {
            return '#90EE90';  // Verde claro quando tem etiqueta
        } else if (order.hasInvoice) {
            return '#F5F5F5';  // Cinza claro quando tem nota fiscal mas não tem etiqueta
        }
        return 'white';  // Cor padrão para outros estados
    };

    return (
        <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '15px',
            padding: '15px',
            borderBottom: '1px solid #eee',
            backgroundColor: getBackgroundColor(),
            transition: 'background-color 0.3s ease'
        }}>
            {/* Checkbox - só aparece se não for readonly */}
            {!readonly && (
                <input
                    type="checkbox"
                    checked={selected}
                    onChange={() => onSelect(order.id)}
                    style={{ cursor: 'pointer' }}
                />
            )}

            {/* Imagem do Produto */}
            <img
                src={order.thumbnail}
                alt={order.title}
                style={{
                    width: '80px',
                    height: '80px',
                    objectFit: 'contain'
                }}
            />

            {/* Informações do Pedido */}
            <div style={{ flex: 1 }}>
                <h3 style={{ margin: '0 0 5px 0', fontSize: '1rem' }}>
                    {order.title}
                </h3>
                <p style={{ margin: '0 0 3px 0', fontSize: '0.9rem', color: '#666' }}>
                    Quantidade: {order.quantity}
                </p>
                <p style={{ margin: '0 0 3px 0', fontSize: '0.9rem', color: '#666' }}>
                    Comprador: {order.buyer}
                </p>
                <p style={{ margin: '0', fontWeight: 'bold', color: '#2D3277' }}>
                    {new Intl.NumberFormat('pt-BR', {
                        style: 'currency',
                        currency: 'BRL'
                    }).format(order.total_amount)}
                </p>
                
                {/* Status da Nota Fiscal */}
                {order.hasInvoice ? (
                    <span style={{ fontSize: '0.8rem', color: '#00a650', marginRight: '10px' }}>
                        Nota Fiscal Emitida
                    </span>
                ) : (
                    <a
                        href={`https://www.mercadolivre.com.br/vendas/${order.id}/detalhe`}
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={e => e.stopPropagation()}
                        style={{ fontSize: '0.8rem', color: '#2D3277', textDecoration: 'underline', cursor: 'pointer' }}
                    >
                        Emitir Nota Fiscal no ML
                    </a>
                )}

                {/* Status da Etiqueta */}
                {order.hasLabel && (
                    <span style={{
                        fontSize: '0.8rem',
                        color: '#0086ff',
                        marginRight: '10px'
                    }}>
                        Etiqueta Gerada
                    </span>
                )}
            </div>
        </div>
    );
};

export default OrderCard;